import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ReceptorService from "../../services/ReceptorService";
import { AnunciosData, GetVoidAnunciosData } from "../../types/Anuncio/AnuncioData";
import { Box, CircularProgress, Container, Grid, IconButton, Typography } from "@mui/material";
import { VerAnuncio } from "../../componente/Anuncio/VerAnuncio";
import { themePalette } from "../../config/theme.config";
import { Iconify } from "../../common/iconify";

export const VerAnuncioPage: React.FC<{}> = () => {
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState(true);
    const [anuncio, setAnuncio] = useState<AnunciosData>(GetVoidAnunciosData());
    const navigate = useNavigate();

    // funcion
    const GetAnuncio = (id: number) => {
        setLoading(true);
        ReceptorService.GetAnuncio(id).then((resp) => {
            setAnuncio(resp.data)
            //console.log(resp)
        }).catch((error) => {
            console.error(error);
        }).finally(() => {
            setLoading(false);
        })
    }

    // Effect
    useEffect(() => {
        GetAnuncio(parseInt(id ?? '0', 10));
    }, []);

    return (
        <Container maxWidth="lg" style={{ padding: '20px', textAlign: 'center', alignContent: 'center', alignItems: 'center', marginTop: 10, border: `1px solid ${themePalette.NAVCOLOR}`, borderTopWidth: '3px', borderRadius: '5px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton onClick={() => navigate(`/`)}>
                    <Iconify
                        width={50}
                        sx={{ color: themePalette.NAVCOLOR }}
                        icon="material-symbols:arrow-back-2-rounded"
                    />
                </IconButton>

                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 'bold',
                        color: themePalette.NAVCOLOR
                    }}
                >
                    COMUNICADO
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', m: 2 }}>
                <Grid container spacing={2}>
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        <VerAnuncio anuncio={anuncio} />
                    )}
                </Grid>
            </Box>
        </Container>
    )
}